import { RootState } from "common/reducers";

const rootKey = "common";

/**
 * Fetches the list of crumbs
 *
 * @param {RootState} state
 * @returns {List<CrumbRecord>}
 */
export const crumbs = (state: RootState, _props?: any) => state.getIn([rootKey, "crumbs"]);

/**
 * Fetches the hamburger menu state
 *
 * @param {RootState} state
 * @returns {boolean}
 */
export const hamburgerMenu = (state: RootState, _props?: any) => state.getIn([rootKey, "hamburgerMenuOpen"]);

/**
 * Fetches the presentation mode state
 * @param {RootState} state
 * @returns
 */
export const presentationMode = (state: RootState, _props?: any) => state.getIn([rootKey, "presentationMode"]);
